import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import BackgroundLayer from '../Transitions/BackgroundLayer';
import PropTypes from 'prop-types';


const SmallSlideOverLayyer = ({ children }) => {
  return (
    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div>
            {children}
          </div>
        </Transition.Child>
      </div>
    </div>
  )
};

SmallSlideOverLayyer.propTypes = {
  children: PropTypes.element.isRequired,
}


export default SmallSlideOverLayyer;